import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus, getCustomHandlerMembership } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetCurrentUserMembershipsMockHandler = () => {
  return http.get('*/user/memberships', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const membership = getCustomHandlerMembership();

    return HttpResponse.json(
      {
        items: membership ? [membership] : [],
        metadata: {
          last_page: faker.helpers.arrayElement([
            faker.number.int({ max: undefined, min: undefined }),
            undefined,
          ]),
          total_count: faker.helpers.arrayElement([
            faker.number.int({ max: undefined, min: undefined }),
            undefined,
          ]),
        },
      },
      {
        status: 200,
      },
    );
  });
};
